import "./loading.css";
import { setinLineStyleProps } from "../../../ui-kit/typography/style-utils";
import useStyles from "../../../hooks/use-styles";

const Loader = (props: { message?: string; style?: object; className?: string }): JSX.Element => {
  const { brandPrimaryColor } = useStyles(["brandPrimaryColor"]);
  const styles = setinLineStyleProps([{ borderTopColor: brandPrimaryColor }]);

  return (
    <div className={`parent-div ${props.className!}`} style={props.style && props.style}>
      <div className="center">
        <div className="loader" {...styles}></div>
      </div>
    </div>
  );
};

export default Loader;
